import { styled } from '@mui/system';
import { Avatar } from '@mui/material';

export const StyledAvatar = styled(Avatar)(({ size = 'medium' }) => {
  let diameter;

  if (size === 'xsmall') {
    diameter = '32px';
  } else if (size === 'small') {
    diameter = '36px';
  } else if (size === 'medium') {
    diameter = '52px';
  } else if (size === 'large') {
    diameter = '104px';
  } else {
    diameter = '52px'; // Fallback to medium if an invalid size is passed
  }

  return {
    width: diameter,
    height: diameter,
  };
});
